


import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const MaterialInspectionRejected = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
            <Modal.Body className="p-5">
                <h4 className="mb-4 fw-bold">Material Inspection Report <span className="text-danger">(Rejected)</span></h4>

                {/* Material Information */}
                <div className="p-3 border rounded bg-light mb-4">
                    <h6 className="fw-semibold">Material Information</h6>
                    <Row className="mt-2">
                        <Col md={6}><strong>ID:</strong> MA-001</Col>
                        <Col md={6}><strong>Material:</strong> Rubber Seals (Type B)</Col>
                    </Row>
                    <Row>
                        <Col md={6}><strong>Expected Qty:</strong> 50 pcs</Col>
                        <Col md={6}><strong>Supplier:</strong> ABC Suppliers</Col>
                    </Row>
                </div>

                {/* NC Report */}
                <div className="p-3 border rounded bg-light mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-semibold mb-0">NC Report by Operator</h6>
                        <Button size="sm" variant="outline-secondary">View Full Report</Button>
                    </div>
                    <p className="mb-3">Lorem ipsum dolor sit amet consectetur. Platea est.</p>

                    <h6 className="fw-semibold mb-2">Inspection Checklist</h6>
                    <Form>
                        <Form.Check label="Visual Inspection (No visible defects)" defaultChecked />
                        <Form.Check label="Dimensional Check (Meets specifications)" defaultChecked />
                        <Form.Check label="Quantity Check (Matches delivery note)" defaultChecked />
                        <Form.Check label="Packaging Condition (No damage)" defaultChecked />
                        <Form.Check label="Material Certificate (Provided and valid)" defaultChecked />
                    </Form>
                </div>

                {/* Product Flaws */}
                {[1, 2].map((_, index) => (
                    <div key={index} className="p-3 mb-3 rounded bg-warning bg-opacity-10 border">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <strong>Product Flaw xyz</strong>
                                <p className="mb-0">Lorem ipsum dolor sit amet consectetur. Platea est.</p>
                            </div>
                            <Button size="sm" variant="outline-secondary">Review Report</Button>
                        </div>
                    </div>
                ))}

                <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                        <Form.Group className="mt-4">
                            <Row>
                                <Col md={2}>
                                    <Form.Label>Notes</Form.Label>
                                </Col>
                                <Col md={10}>
                                    <Form.Control as="textarea" rows={3} placeholder="Additional notes or observations" />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer  className="border-0">
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="dark">
                    Joint Inspection
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaterialInspectionRejected;
